import { render, staticRenderFns } from "./DebtorAdjustmentSideMenu.vue?vue&type=template&id=4d6e3a1b"
import script from "./DebtorAdjustmentSideMenu.vue?vue&type=script&lang=js"
export * from "./DebtorAdjustmentSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6e3a1b')) {
      api.createRecord('4d6e3a1b', component.options)
    } else {
      api.reload('4d6e3a1b', component.options)
    }
    module.hot.accept("./DebtorAdjustmentSideMenu.vue?vue&type=template&id=4d6e3a1b", function () {
      api.rerender('4d6e3a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtoradjustment/DebtorAdjustmentSideMenu.vue"
export default component.exports